import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_CONTACTS,
    FETCH_CONTACTS_FAILURE,
    FETCH_CONTACTS_SUCCESS,
    FETCH_GEOCODE,
    FETCH_GEOCODE_ERROR,
    FETCH_GEOCODE_SUCCESS,
    FETCH_GEOCODE_POINT,
    FETCH_GEOCODE_POINT_FAILURE,
    FETCH_GEOCODE_POINT_SUCCESS,
    INITIALIZE_VALUES,
    RESET,
    RESET_FORM,
    SAVE_PROJECT,
    SAVE_PROJECT_SUCCESS,
    SAVE_PROJECT_FAILURE,
    SET_IS_NEW_RECORD,
    SET_IS_OPEN_MODAL,
    SET_SHOW_GEOCODE_RESULTS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    contacts: {
        data: [],
        errors: [],
        isFetching: false,
    },
    fetchGeocode: {
        data: [],
        errors: [],
        isLoading: false,
    },
    fetchGeocodePoint: {
        isFetching: false,
        data: null,
        errors: [],
    },
    initialValues: {
        address: '',
        city: '',
        contact: null,
        contact_name: '',
        country: '',
        id: null,
        latitude: '',
        longitude: '',
        name: '',
        position: {},
        state: '',
    },
    isNewRecord: false,
    isOpenModal: false,
    saveProject: {
        isSaving: false,
        errors: [],
    },
    showGeocodeResults: false,
};

const createProjectModalSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_CONTACTS]: (state) => {
            state.contacts = {
                ...state.contacts,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_CONTACTS_FAILURE]: (state, action) => {
            state.contacts = {
                ...state.contacts,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_CONTACTS_SUCCESS]: (state, action) => {
            state.contacts = {
                ...state.contacts,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_GEOCODE]: (state) => {
            state.fetchGeocode = {
                ...state.fetchGeocode,
                errors: [],
                isLoading: true,
            };
        },
        [FETCH_GEOCODE_ERROR]: (state, action) => {
            state.fetchGeocode = {
                ...state.fetchGeocode,
                data: [],
                errors: action.payload,
                isLoading: false,
            };
        },
        [FETCH_GEOCODE_SUCCESS]: (state, action) => {
            state.fetchGeocode = {
                ...state.fetchGeocode,
                data: action.payload,
                errors: [],
                isLoading: false,
            };
        },
        [FETCH_GEOCODE_POINT]: (state) => {
            state.fetchGeocodePoint = {
                ...state.fetchGeocodePoint,
                data: null,
                isFetching: true,
            };
        },
        [FETCH_GEOCODE_POINT_FAILURE]: (state, action) => {
            state.fetchGeocodePoint = {
                ...state.fetchGeocodePoint,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_GEOCODE_POINT_SUCCESS]: (state, action) => {
            state.fetchGeocodePoint = {
                ...state.fetchGeocodePoint,
                data: action.payload,
                errors: [],
                isFetching: false,
            };
        },
        [INITIALIZE_VALUES]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [RESET]: () => INITIAL_STATE,
        [RESET_FORM]: (state) => {
            state.initialValues = INITIAL_STATE.initialValues;
        },
        [SAVE_PROJECT]: (state) => {
            state.saveProject = {
                ...state.saveProject,
                errors: [],
                isSaving: true,
            };
        },
        [SAVE_PROJECT_FAILURE]: (state, action) => {
            state.saveProject = {
                ...state.saveProject,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_PROJECT_SUCCESS]: (state, action) => {
            state.saveProject = {
                ...state.saveProject,
                data: action.payload,
                isSaving: false,
            };
        },
        [SET_IS_NEW_RECORD]: (state, action) => {
            state.isNewRecord = action.payload;
        },
        [SET_IS_OPEN_MODAL]: (state, action) => {
            state.isOpenModal = action.payload;
        },
        [SET_SHOW_GEOCODE_RESULTS]: (state, action) => {
            state.showGeocodeResults = action.payload;
        },
    },
});

export const createProjectModalActions = createProjectModalSlice.actions;

export default createProjectModalSlice.reducer;
